import { Form, Formik } from "formik";
import { postReview } from "@/src/models/review";

import { gaLoadedPromise, gaWriteCommentClick } from "@/src/utils/gtagEvents";
// import { hideToast, loadingToast } from "@/commComponents/Toast";
import { FmButton, FmToast } from "@/ui-component";
import { useCallback, useState } from "react";
import { isLogin } from "@/src/models/loginModel";
import stl from "./reviewCommentForm.module.scss";
import classnames from "classnames";
import { useTranslation } from "@/src/i18n/client";

interface IProps {
    header: string;
    id: number;
    productId: number;
    changeTotal: (data: any) => void;
}

interface IInitValue {
    commentContent: string;
}
const ReviewCommentForm: React.FC<IProps> = (props) => {
    const [toastVisible, setToastVisible] = useState(false);
    const [toastChildren, setToastChildren] = useState("");
    const [toastType, setToastType] = useState<"info" | "loading">("info");
    const { header, id, productId, changeTotal } = props;

    const { t } = useTranslation(["review", "common"]);

    const showToastByType = (
        type: "info" | "loading",
        children: string = "",
        seconds?: number,
        cb?: Function,
        data?: Record<string, any>,
    ) => {
        setToastType(type);
        setToastChildren(children);
        setToastVisible(true);
        if (seconds) {
            setTimeout(() => {
                setToastVisible(false);
                cb && cb(data);
            }, seconds * 1000);
        }
    };
    const comment = useCallback((data: Record<string, any>, cb: Function) => {
        if (isLogin()) {
            showToastByType("loading");
            const promise = postReview(data);
            promise
                .then(
                    (res) => {
                        showToastByType("info", res.msg, 1, cb, data);
                    },
                    (e) => {
                        showToastByType("info", e, 1);
                    },
                )
                .catch((e) => {
                    showToastByType("info", e?.message ?? e?.msg, 1);
                });
            //GA评价
            gaLoadedPromise()
                .then((res) => {
                    gaWriteCommentClick();
                })
                .catch((e) => {
                    console.log(e);
                });
        } else {
            // TODO: 这里是不是要做一个用户没有登录的提示
            null;
        }
    }, []);

    const handleSubmit = useCallback(
        (values: IInitValue, {}) => {
            const data = {
                parent_id: id,
                reviews_type: 1,
                reviews_text: values.commentContent,
                products_id: productId,
            };
            comment(data, changeTotal);
        },
        [comment, changeTotal, id, productId],
    );
    return (
        <>
            {/* 提交loading && 成功提示 */}
            <FmToast visible={toastVisible} type={toastType}>
                {toastChildren}
            </FmToast>
            <Formik
                initialValues={{ commentContent: "" }}
                onSubmit={handleSubmit}
                validate={(values) => {
                    const errors: Record<string, any> = {};
                    if (!values.commentContent) {
                        errors.commentContent = "commentContent is Required";
                    }
                    return errors;
                }}
            >
                {({ values, setFieldValue }) => (
                    <Form className={stl["review-comment-container"]}>
                        <div className={classnames(stl["review-comment-who"])}>
                            <span className={stl["review-comment-heard"]}>
                                {"@" + header}
                            </span>
                        </div>
                        <input
                            className={stl["review-comment-input"]}
                            name="commentContent"
                            defaultValue={values.commentContent}
                            onChange={(e) => {
                                setFieldValue("commentContent", e.target.value);
                            }}
                            placeholder={`${t("review:Reply")}:${header}`}
                        />
                        <FmButton
                            size={"small"}
                            variant={"contained"}
                            type="submit"
                            disabled={!values.commentContent}
                        >
                            {t("common:Comment")}
                        </FmButton>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default ReviewCommentForm;
